<style scoped>
::v-deep .product-info-wrapper {
    max-height: 50vh;
    overflow-y: auto;
}

::v-deep .text-external-urls {
    width: auto;
}
</style>

<template>
    <div>
        <breadcrumb :links="links" />
        <productDetailContent
            v-if="product"
            :product="product"
            class="px-2 md:pl-16 md:pr-4"
        />
    </div>
</template>

<script>
import breadcrumb from '@/components/breadcrumb.vue';
import price from '@/components/priceFilter';
import productDetailContent from '@/components/productDetailContent.vue';

export default {
    components: {
        breadcrumb,
        productDetailContent
    },
    filters: { price },
    mounted() {
        if (this.$store.state.user) {
            this.$store.dispatch('saveCustProdViewHist', this.product);
        }
    },
    computed: {
        links() {
            const prodGroupLink = {
                msg: this.product.saleCatgSlctDesp,
                route: this.$store.getters.productGroupRoute(
                    this.product.saleCatgSlctCode
                )
            };
            const prodCatgLink = {
                msg: this.prodCatgDesp,
                route: this.$store.getters.productGroupRoute(
                    this.product.saleCatgSlctCode,
                    this.product.prodCatgSlctKey || 0
                )
            };
            const prodLink = {
                text: this.$config.showProdName
                    ? this.productDisplayFullname
                    : this.$t('product.info')
            };

            const links = [];
            links.push(prodGroupLink);
            links.push(prodCatgLink);
            links.push(prodLink);
            return links;
        },
        product() {
            return this.$store.getters.productList.find(
                p => p.id == this.$route.params.id
            );
        },
        productDisplayFullname() {
            return this.$store.getters.productDisplayFullname(
                this.product,
                true
            );
        },
        previewCmpyToken() {
            return this.$store.getters.previewCmpyToken;
        },
        prodCatgList() {
            return this.$store.state.prodCatgList || [];
        },
        prodCatgDesp() {
            const prodCatg = this.prodCatgList.filter(
                prodCatg => prodCatg.id === this.product.prodCatgSlctKey
            );
            return this.product.prodCatgSlctKey ? prodCatg[0].slctDesp : '其他';
        }
    }
};
</script>
